var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "py-2 sm:py-4 md:py-6 px-7 bg-white reviewTab" },
    [
      _c(
        "LoadingOverlay",
        { attrs: { hasData: !!_vm.ratings, loading: _vm.$apollo.loading } },
        [
          _vm.showEmptyListPlaceholder
            ? _c(
                "EmptyListPlaceholder",
                {
                  attrs: {
                    title: _vm.emptyListTitle,
                    subtitle: _vm.emptyListSubtitle,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "image",
                        fn: function () {
                          return [_c("EmptyListImageReviews")]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2937895862
                  ),
                },
                [
                  !_vm.myReview
                    ? _c("UiButtonMessage", {
                        attrs: {
                          buttonText: "Add review",
                          label: "add black",
                          buttonClass: "customAdd",
                        },
                        on: { click: _vm.toggleReviewModal },
                      })
                    : _vm._e(),
                ],
                1
              )
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-row justify-between items-center pb-4",
                  },
                  [
                    _c("CardBodyItem", {
                      staticClass: "mb-0.5",
                      attrs: {
                        label: "Reviews",
                        totalNumber: _vm.ratings.length,
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "mb-4" },
                      [
                        _c("UiButtonMessage", {
                          attrs: {
                            buttonText: "Add review",
                            label: "add black",
                            buttonClass: "customAdd",
                          },
                          on: { click: _vm.toggleReviewModal },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._l(_vm.ratings, function (rating) {
                  return _c("ContractorReviewNew", {
                    key: rating.id,
                    attrs: {
                      rating: rating,
                      currentUserRole: _vm.currentUserRole,
                      currentUserId: _vm.currentUserId,
                      contractorId: _vm.contractorId,
                    },
                    on: { reviewDeleted: _vm.refetchReviews },
                  })
                }),
              ],
          _vm.isDataLoaded
            ? _c("CardPagination", {
                attrs: { config: _vm.paginationConfig },
                on: {
                  "update:config": function ($event) {
                    _vm.paginationConfig = $event
                  },
                },
              })
            : _vm._e(),
          _vm.dialog
            ? _c("ReviewModal", {
                attrs: {
                  contractorId: _vm.contractorId,
                  currentUserId: _vm.currentUserId,
                },
                on: {
                  close: _vm.toggleReviewModal,
                  reviewCreated: _vm.refetchReviews,
                },
              })
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }